/**
 * @file
 * Tethys USWDS global js file.
 */

(function (Drupal, $, once) {
  'use strict';

  // Add behavior to style links.
  Drupal.behaviors.processLinks = {
    attach: function (context) {
      once('link-processed', 'a[href]', context).forEach(function(link) {
        var href = $(link).attr('href');
        if (href.length > 1 &&
            !($(link).find('img').length > 0) && 
            !($(link).find('svg').length > 0) && 
            !($(link).find('.usa-icon').length > 0) && 
            !($(link).hasClass('colorbox'))) {
          // Add standard link class.
          if (!$(link).hasClass('usa-button') &&
            !$(link).hasClass('usa-link')) {
            $(link).addClass('usa-link');
          }
          // Handle external links.
          if (href.startsWith('http') && 
              !href.includes('tethys-dev.pnl.gov') && 
              !href.includes('tethys.pnnl.gov') &&
              !$(link).hasClass('usa-link--external')) {
            $(link).addClass('usa-link--external').attr('rel', 'noreferrer');
          }
        }
      });
    }
  }

  // SEO fix to make Chosen link items crawlable.
  Drupal.behaviors.chosenAccessibility = {
    attach: function (context) {
      once('chosenAccessibility', '.chosen-single', context).forEach(function (link) {
        link.setAttribute('href', '#');
      });
    }
  }

})(Drupal, jQuery, once);
